/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.pageNotFound.controllers', [])

.controller('PageNotFoundController', ['$scope', function($scope) {

    $scope.pageNotFound = {

      model: "Your spankin new pageNotFound view!",

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Page not found'
        });
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.pageNotFound.init();

}]);